<template>
    <div class="skills-container">

        <div class="skills-intro">
            <h1 class="skills-h1">here's a quick look at what I can do...</h1>
            <p class="skills-blurb">
                Working across design and front end development helps me carry ideas all the way through. I start by thinking deeply about flows, systems, and interaction details, grounding decisions in research and usability. Because I understand how things get built, I can partner closely with engineering or step into the code when needed to make sure the final experience is clean, accessible, and true to the original intent.  That space where thoughtful design meets real implementation is where I do my best work.
            </p>
        </div>

        <div class="skills-sections">

            <div class="skills-section">
                <div class="skills-section-header">
                    <span class="skills-label">01</span>
                    <h2 class="skills-section-title">Design</h2>
                </div>
                <ul class="skills-list">
                    <li class="skill-item" v-for="skill in designSkills" :key="skill">{{ skill }}</li>
                </ul>
            </div>

            <div class="skills-section">
                <div class="skills-section-header">
                    <span class="skills-label">02</span>
                    <h2 class="skills-section-title">Development</h2>
                </div>
                <ul class="skills-list">
                    <li class="skill-item" v-for="skill in devSkills" :key="skill">{{ skill }}</li>
                </ul>
            </div>

        </div>

    </div>
</template>

<script>
export default {
    name: 'SkillsPage',
    data() {
        return {
            designSkills: [
                'Figma',
                'Wireframing & Prototyping',
                'Interaction Design',
                'Design Systems',
                'Usability Testing',
                'User Research',
                'Responsive Design',
                'Accessibility (WCAG)',
                'AI-Assisted Design Workflows',
                'Adobe Suite',
            ],
            devSkills: [
                'HTML5 & CSS3',
                'JavaScript',
                'TypeScript',
                'Vue.js',
                'Sass / SCSS',
                'Git',
                'npm',
                'WCAG Implementation',
                'Design Handoff',
                'Agile Methods',
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';

.skills-container {
    margin: 100px auto 0 auto;
    width: 80%;
    max-width: 900px;
    padding-bottom: 100px;
}

/* ── Intro ─────────────────────────────────────────────────────────────────── */
.skills-intro {
    margin-bottom: 72px;
    max-width: 640px;
}

.skills-h1 {
    font-size: 32px;
    color: $green;
    margin-bottom: 24px;
}

.skills-blurb {
    font-size: 18px;
    color: #4a4a3a;
    line-height: 1.7;
}

/* ── Two-column sections ───────────────────────────────────────────────────── */
.skills-sections {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0;
    border-top: 1.5px solid $green;

    @media all and (max-width: 680px) {
        grid-template-columns: 1fr;
    }
}

.skills-section {
    padding: 40px 48px 48px 0;

    &:last-child {
        padding-left: 48px;
        padding-right: 0;
        border-left: 1.5px solid $green;

        @media all and (max-width: 680px) {
            padding-left: 0;
            border-left: none;
            border-top: 1.5px solid $green;
        }
    }

    @media all and (max-width: 680px) {
        padding: 36px 0 40px;
    }
}

/* ── Section header ────────────────────────────────────────────────────────── */
.skills-section-header {
    display: flex;
    align-items: baseline;
    gap: 14px;
    margin-bottom: 32px;
}

.skills-label {
    font-size: 12px;
    font-weight: 500;
    color: $green;
    opacity: 0.5;
    letter-spacing: 0.08em;
    font-family: 'Poppins', sans-serif;
}

.skills-section-title {
    font-size: 28px;
    font-weight: 400;
    color: $green;
    margin: 0;
}

/* ── Skill list ────────────────────────────────────────────────────────────── */
.skills-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.skill-item {
    font-size: 18px;
    color: #4a4a3a;
    padding: 11px 0;
    border-bottom: 1px solid rgba(105, 117, 67, 0.12);
    transition: color 0.18s, padding-left 0.18s;
    cursor: default;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        color: $green;
        padding-left: 8px;
    }
}
</style>